module.exports = [{"brand":"Owon","models":[{"name":"pct503"}]}]


//////////////////
// WEBPACK FOOTER
// ./components/thermostats/SupportedThermostats.json
// module id = 1194
// module chunks = 7